import { useEffect } from 'react';
import './App.css';
import About from './components/About';
import Beneficios from './components/Beneficios';
import Header from './components/Header';
import Hero from './components/Hero';
import Equipamentos from './components/Equipamentos';
import Avaliacaoes from './components/Avaliacaoes';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  useEffect(() => {
    if (window.__gmedScriptLoaded) {
      return;
    }

    const existing = document.querySelector('script[data-gmed-script]');
    if (existing) {
      window.__gmedScriptLoaded = true;
      return;
    }

    const script = document.createElement('script');
    script.src = `${process.env.PUBLIC_URL}/script.js`;
    script.async = true;
    script.dataset.gmedScript = 'true';
    document.body.appendChild(script);
    window.__gmedScriptLoaded = true;
  }, []);

  return (
    <div className="App">
      <Header />
      <Hero />
      <About />
      <Beneficios />
      <Equipamentos />
      <Avaliacaoes />
      <Contact />
      <Footer />

      <a href="https://wa.me/5519978291299" className="whatsapp-float" target="_blank" rel="noreferrer">
        <i className="fab fa-whatsapp"></i>
      </a>

      <div className="cookie-bar" id="cookieBar">
        <p>
          Nós utilizamos cookies para garantir que você tenha a melhor experiência em nosso site.
          Se você continua a usar este site, assumimos que você está satisfeito.
        </p>
        <button id="cookieBtn">Ok</button>
      </div>
    </div>
  );
}

export default App;
